export default function Footer() {
  return (
    <footer
      className="border-t border-[#FAF9F6]/10 py-14"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3">
              <img
                src="/emblem-ricciardi.png"
                alt="Emblema Studio Legale Ricciardi"
                className="h-10 w-auto"
                data-testid="footer-emblem"
              />
              <div className="h-9 w-9 border border-[#C5A880] flex items-center justify-center">
                <span className="font-display text-sm font-bold text-[#C5A880]">
                  R
                </span>
              </div>
              <div>
                <div className="font-display text-base font-semibold">
                  Studio Legale Ricciardi
                </div>
                <div className="overline text-[10px]">
                  Diritto Commerciale · Societario · Immobiliare
                </div>
              </div>
            </div>
            <p className="mt-6 text-sm text-[#FAF9F6]/55 max-w-md leading-relaxed">
              Studio legale specialistico in diritto societario, operazioni
              di M&amp;A, governance e diritto immobiliare. Assistenza legale
              con approccio pragmatico, orientato al business.
            </p>
          </div>

          <div className="lg:col-span-3">
            <div className="overline mb-4">Aree Legali</div>
            <ul className="space-y-2 text-sm text-[#FAF9F6]/65">
              <li>Diritto commerciale</li>
              <li>Diritto societario · M&amp;A</li>
              <li>Diritto immobiliare</li>
              <li>Contenzioso & recupero crediti</li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="overline mb-4">Studio</div>
            <ul className="space-y-2 text-sm text-[#FAF9F6]/65">
              <li>
                <a
                  href="/approfondimenti"
                  className="hover:text-[#C5A880] transition-colors"
                  data-testid="footer-approfondimenti-link"
                >
                  Approfondimenti
                </a>
              </li>
              <li>info@ricciardistudiolegale.com</li>
              <li>Napoli · Milano</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-[#FAF9F6]/10 flex flex-col sm:flex-row justify-between gap-4 text-xs text-[#FAF9F6]/40">
          <div>
            © {new Date().getFullYear()} Studio Legale Ricciardi. Tutti i
            diritti riservati. · P.IVA 09934351215
          </div>
          <div className="flex gap-6">
            <a href="#" className="hover:text-[#C5A880] transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-[#C5A880] transition-colors">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
